import { AUTH_URL, API_URL, DEFAULT_LOCALE, MESSAGE_ERROR_AUTH, LOGIN_PAGE_URLS } from '../env/config';

export class AuthenticationError extends Error {
  constructor(message, code = 'AUTH_ERROR') {
    super(message);
    this.name = 'AuthenticationError';
    this.code = code;
  }
}

export async function getAuthentication(email, password) {
  if (!email || !password) {
    throw new AuthenticationError('Email y contraseña son requeridos', 'VALIDATION_ERROR');
  }

  try {
    // Autenticación en Strapi
    const response = await fetch(AUTH_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ identifier: email, password }),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const errorMessage = data.error?.message || MESSAGE_ERROR_AUTH;
      throw new AuthenticationError(errorMessage, 'AUTH_FAILED');
    }

    // Obtener perfil del usuario
    const location = localStorage.getItem('LANGUAGE') || DEFAULT_LOCALE;
    const profileUrl = `${API_URL}/users/me?populate=*&locale=${location}`;

    const profileResponse = await fetch(profileUrl, {
      headers: { 'Authorization': `Bearer ${data.jwt}` },
    });

    if (!profileResponse.ok) {
      console.warn('No se pudo cargar el perfil del usuario');
      return { ...data, profile: null };
    }

    const profileData = await profileResponse.json();
    return { ...data, profile: profileData };

  } catch (error) {
    if (error instanceof AuthenticationError) throw error;
    
    console.error('Error en la autenticación:', error);
    
    if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
      throw new AuthenticationError(
        'No se pudo conectar al servidor. Verifique su conexión a internet.',
        'NETWORK_ERROR'
      );
    }
    
    throw new AuthenticationError(
      'Ocurrió un error inesperado. Por favor, intente nuevamente.',
      'UNKNOWN_ERROR'
    );
  }
}

export async function loadLoginPageData() {
  try {
    // Obtener el idioma actual del localStorage
    const currentLang = localStorage.getItem('LANGUAGE') || DEFAULT_LOCALE;
    
    // Obtener la URL correcta según el idioma
    let loginPageUrl = LOGIN_PAGE_URLS[currentLang] || LOGIN_PAGE_URLS[DEFAULT_LOCALE];
    
    console.log('Cargando datos de login para el idioma:', currentLang);
    console.log('URL de la API:', loginPageUrl);
    
    const response = await fetch(loginPageUrl);
    
    if (!response.ok) {
      console.error('Error en la respuesta de la API:', await response.text());
      throw new Error('Error al cargar la configuración');
    }
    
    const result = await response.json();
    console.log('Datos recibidos de la API:', result);
    
    // Verificar si la respuesta tiene la estructura esperada
    if (result?.data) {
      // Si hay atributos, devolverlos, de lo contrario devolver el objeto data completo
      return result.data.attributes || result.data;
    }
    
    return {};
  } catch (error) {
    console.error('Error cargando datos de la página de login:', error);
    return {};
  }
}